var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ATagHintPage"},[_c('div',{staticClass:"hintText"},[_vm._v("如需浏览，请长按网址复制后使用浏览器访问")]),_c('div',{staticClass:"urlText"},[_vm._v(_vm._s(_vm.url))])])
}
var staticRenderFns = []

export { render, staticRenderFns }